import styled from "styled-components";
import { ThemeType } from "../../../interfaces/event/config";

export const Container = styled.div<{themeType: ThemeType, colapsed?: boolean}>`
  display: flex;
  padding: ${props => props.colapsed ? '0' : '8px 20px'};
  justify-content: center;
  align-items: center;
  border-radius: ${props => props.colapsed ? '50%' : '120px'}; 
  gap: 8px;
  width: ${props => props.colapsed ? '38px' :'auto'};
  height: ${props => props.colapsed ? '38px' :'auto'};

  transition: all 0.5s;

  cursor: pointer;

  background-color: ${
    props => props.themeType === 'light' ? 
     (props.colapsed ?  props.theme.colors.white :  props.theme.colors.inputBackground) : 
      props.theme.colors.label
  };
`;